import SEOTestPage from '../../components/SEOTestPage';
import { SEO_TESTS } from '../../data/seoTestsConfig';
export default function DersVerimliTestiPage() {
  return <SEOTestPage testConfig={SEO_TESTS['ders-verimliligi-testi']} />;
}
